import { css } from 'linaria';

export const dropzoneNoLabel = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;

  box-sizing: border-box;
  width: var(--space-1000);
  height: var(--space-1000);
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  transition: background-color 0.3s;
  cursor: pointer;

  &:hover {
    background-color: var(--control-hover-secondary);
  }
`;
